<div class="modal-wrapper">
  <div class="modal-header">
    <h2 class="h6_500 modal-title" mat-dialog-title>
      {{ title | translate }}
    </h2>
    <common-icon-button
      class="modal-close-button"
      variant="plain"
      icon="close"
      iconSet="material-icons-outlined"
      ariaLabel="Close"
      color="weak"
      type="filled"
      size="small"
      [stopClickPropagation]="true"
      (output)="onEventClose()"
    ></common-icon-button>
  </div>

  <!-- Contenido del modal -->
  <mat-dialog-content class="modal-content">
    <div class="modal-form">
      <single-select-input
        [options]="options"
        [label]="inputLabel"
        [placeholder]="inputLabel"
        [disabled]="selectDisabled"
        [typeSearch]="'local'"
        [initialValue]="selectedValue"
        [clearValue]="clearValue"
        [valueFn]="valueFn"
        [displayFn]="displayFn"
        (outputSelect)="onOptionSelected($event)">
      </single-select-input>

      <p *ngIf="inputHint" class="modal-hint">{{ inputHint | translate }}</p>

      <app-common-checkbox
        *ngIf="checkboxOption && checkboxControl"
        type="check_box"
        [labelKey]="checkboxOption.labelKey"
        labelPosition="after"
        [formControl]="checkboxControl"
      ></app-common-checkbox>
    </div>
  </mat-dialog-content>

  <!-- Acciones del modal -->
  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="labelButtonCancel | translate"
      [disabled]="loading" 
      [iconPosition]="false" 
      (output)="onEventCancel()">
    </common-buttons-outlined>

    <common-buttons-filled
      [label]="labelButtonSave | translate"
      [disabled]="loading || !canSave" 
      [iconPosition]="false" 
      (output)="onEventSave()">
    </common-buttons-filled>
  </mat-dialog-actions>
</div>
